
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import api from '../api';
import Modal from '../components/Modal';
import LoadingSpinner from '../components/LoadingSpinner';
import './OurCost.css';

function OurCost() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    service_type: 'web-development',
    description: '',
    budget: '',
    name: '',
    phone: '',
    email: ''
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', message: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await api.post('/our-cost', formData);
      setModalContent({
        title: t('our_cost.modal_success_title'),
        message: t('our_cost.modal_success_message')
      });
      setIsModalOpen(true);
      setFormData({
        service_type: 'web-development',
        description: '',
        budget: '',
        name: '',
        phone: '',
        email: ''
      });
    } catch (error) {
      setModalContent({
        title: t('our_cost.modal_error_title'),
        message: t('our_cost.modal_error_message')
      });
      setIsModalOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="our-cost-page">
      {isLoading && <LoadingSpinner />}
      <section className="modern-hero">
        <div className="hero-content">
          <h1>{t('our_cost.hero_title')}</h1>
          <p>{t('our_cost.hero_subtitle')}</p>
        </div>
      </section>

      <section className="pricing-factors">
        <div className="pricing-factor">
          <div className="pricing-factor-icon">📏</div>
          <h2>{t('our_cost.scope_title')}</h2>
          <p>{t('our_cost.scope_text')}</p>
        </div>
        <div className="pricing-factor">
          <div className="pricing-factor-icon">⏳</div>
          <h2>{t('our_cost.timeline_title')}</h2>
          <p>{t('our_cost.timeline_text')}</p>
        </div>
        <div className="pricing-factor">
          <div className="pricing-factor-icon">🎨</div>
          <h2>{t('our_cost.design_title')}</h2>
          <p>{t('our_cost.design_text')}</p>
        </div>
        <div className="pricing-factor">
          <div className="pricing-factor-icon">⚙️</div>
          <h2>{t('our_cost.tech_title')}</h2>
          <p>{t('our_cost.tech_text')}</p>
        </div>
      </section>

      <section className="contact-form-section">
        <h2 className="form-title">{t('our_cost.form_title')}</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="service-type">{t('our_cost.form_service_type')}</label>
            <select id="service-type" name="service_type" value={formData.service_type} onChange={handleChange}>
              <option value="web-development">{t('our_cost.service_web_development')}</option>
              <option value="mobile-app-development">{t('our_cost.service_mobile_app_development')}</option>
              <option value="seo-optimization">{t('our_cost.service_seo_optimization')}</option>
              <option value="online-shop">{t('our_cost.service_online_shop')}</option>
              <option value="data-analysis">{t('our_cost.service_data_analysis')}</option>
              <option value="process-automation">{t('our_cost.service_process_automation')}</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="description">{t('our_cost.form_description')}</label>
            <textarea id="description" name="description" rows="5" value={formData.description} onChange={handleChange}></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="budget">{t('our_cost.form_budget')}</label>
            <input type="number" id="budget" name="budget" value={formData.budget} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="name">{t('our_cost.form_name')}</label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="phone">{t('our_cost.form_phone')}</label>
            <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="email">{t('our_cost.form_email')}</label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} />
          </div>
          <button type="submit" className="submit-button">{t('our_cost.form_submit')}</button>
        </form>
      </section>

      <section className="final-cta-our-cost">
        <div className="final-cta-content-our-cost">
          <h2>{t('our_cost.final_cta_title')}</h2>
          <p>{t('our_cost.final_cta_text')}</p>
          <Link to="/kontakt" className="cta-button-our-cost">{t('our_cost.final_cta_button')}</Link>
        </div>
      </section>

      <Modal isOpen={isModalOpen} onClose={closeModal} title={modalContent.title}>
        <p>{modalContent.message}</p>
      </Modal>
    </div>
  );
}

export default OurCost;
